import { SalesChannelOverlay } from '#app/routes/mocra+/_form+/components/sales-channels/overlay.tsx'
import { type SalesChannelDraft } from '#app/routes/mocra+/_form+/components/sales-channels/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: SalesChannelDraft) => void
	readonly initialValue: SalesChannelDraft
	readonly onClosed?: () => void
}

export function SalesChannelEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
}: Props) {
	return (
		<SalesChannelOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
		/>
	)
}
